<template>
  <div class="abs-affiliazioni" >

    <div class="row">
        <div class="col s3" v-if="false">
            <el-form-item >
                <el-input  v-model="affiliazione.id"></el-input>
            </el-form-item>
        </div>
        <div class="col s10">
            <el-form-item :label="$teras.lang.affiliazione">
                <el-input  v-model="affiliazione.nome"></el-input>
            </el-form-item>
        </div>
        <div class="col s2">
            <el-tooltip v-if="affiliazione.id==-1" class="item" effect="dark" :content="$teras.lang.aggiungi" placement="top"><el-button type="primary" icon="plus" @click="addNow"></el-button></el-tooltip>
            <el-tooltip v-if="affiliazione.id>-1" class="item" effect="dark" :content="$teras.lang.salvamodifiche" placement="top"><el-button  type="success" icon="edit" @click="editNow"></el-button></el-tooltip>
            <el-tooltip v-if="affiliazione.id>-1" class="item" effect="dark" :content="$teras.lang.cancella" placement="top"><el-button  type="danger" icon="delete" @click="delNow"></el-button></el-tooltip>
        </div>
    </div>

 
  <div class="row pad help" v-if="$teras.affiliazioni.length>0">
    <div class="col s2 yo-align-right"><i class="material-icons">live_help</i></div>
    <div class="col s10" v-html="$teras.lang.affiliazioniOrderHelp"></div>
  </div>


    <draggable :list="$teras.affiliazioni" class="dragArea" @end="onEnd" v-if="$teras.affiliazioni.length>0">
        <div v-for="(element, index) in $teras.affiliazioni" @click="onEdit(element)" :key="element.id">{{index+1}} {{element.nome}}</div>
    </draggable>


  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'abs-affiliazioni',
  components: {
    draggable
  },
  created () {
    console.log("Arrivo al abs-affiliazioni.vue");
  },
  data() {
    return {
      options: {},
      affiliazione:{
        id:-1,
        nome: ''
      },
    }
  },
  methods: {
    onEnd(){
    },
    onEdit(affiliazione){
      this.affiliazione.id=affiliazione.id
      this.affiliazione.nome=affiliazione.nome
    },
    delNow(){
      for ( const affiliazione of this.$teras.affiliazioni){
        //console.log(affiliazione)
        if(affiliazione.id == this.affiliazione.id){
          console.log(this.$teras.affiliazioni.indexOf(affiliazione))
          this.$teras.affiliazioni.splice(this.$teras.affiliazioni.indexOf(affiliazione),1)
          this.reset()
        }
      }
    },
    addNow(){
      this.affiliazione.id = this.$teras.affiliazioni.length
      this.$teras.affiliazioni.push({id:this.affiliazione.id,cognome:this.affiliazione.cognome,nome:this.affiliazione.nome})
      this.reset()
    },
    editNow(){
      for (let affiliazione of this.$teras.affiliazioni)
        if(affiliazione.id == this.affiliazione.id){
          affiliazione.nome=this.affiliazione.nome
        }
      this.reset()
    },
    reset(){
      this.affiliazione.id=-1
      this.affiliazione.nome=''
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// Abs-affiliazioni.vue?fbb54746